import { applyJobPhasesPolicy } from './jobPhases.js';
import { applyPolicySliders } from './sliders.js';
import { applyApiDefaults } from './apiDefaults.js';
import { applyUploadsPolicy, applyResizePolicy } from './uploads.js';
import { applyUploadLimitsPolicy } from './uploadLimits.js';
import { applyJobMonitoringPolicy } from './jobMonitoring.js';
import { applyJobLimitsPolicy } from './jobLimits.js';

export async function loadPolicyConfig() {
    try {
        const res = await fetch('/config');
        if (!res.ok) return null;
        return await res.json();
    } catch (e) {
        return null;
    }
}

export function applyPolicyConfig(policy) {
    if (!policy) return false;
    applyJobPhasesPolicy(policy);
    if (policy.sliders) applyPolicySliders(policy.sliders);
    if (policy.api_defaults) applyApiDefaults(policy.api_defaults);
    if (policy.upload_queue) applyUploadsPolicy(policy.upload_queue);
    if (policy.upload_limits) applyUploadLimitsPolicy(policy.upload_limits);
    if (policy.upload_resize) applyResizePolicy(policy.upload_resize);
    if (policy.job_monitoring) applyJobMonitoringPolicy(policy.job_monitoring);
    if (policy.job_limits) applyJobLimitsPolicy(policy.job_limits);
    return true;
}

export async function loadAndApplyPolicyConfig() {
    const policy = await loadPolicyConfig();
    if (policy) {
        applyPolicyConfig(policy);
        return policy;
    }
    return null;
}
